<template>
  <div class="countdown">
    <!-- {{detailTransaction}} -->
    <PaymentPending :data="detailTransaction" v-if="this.query.transaction_status == 'pending'"></PaymentPending>
    <PaymentSucces :data="detailTransaction"
      v-else-if="(this.query.transaction_status == 'paid' || this.query.transaction_status == 'settlement')">
    </PaymentSucces>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import PaymentPending from "@/views/store/cart/PaymentPending";
import PaymentSucces from "@/views/store/cart/PaymentSucces";
export default {
  components: {
    PaymentPending,
    PaymentSucces
  },
  data() {
    return {
      memberMLMUrl: process.env.VUE_APP_MLM_MEMBER_URL,
      query: {
        order_id: "",
        status_code: "",
        transaction_status: ""
      }
    };
  },
  computed: {
    ...mapState("transaction", ["detailTransaction"])
  },
  methods: {
    ...mapActions("transaction", ["getTransactionDetail"]),
    ...mapMutations("transaction", ["clearTransaction"]),

    downloadPDF(pdf) {
      window.open(pdf);
    }
  },
  created() {
    Object.assign(this.query, this.$route.query);
    this.getTransactionDetail({
      invoice: this.query.order_id
    }).catch(() => {
      let orderId = this.query.order_id;
      let firstTwoChars = orderId.slice(0, 2);
      if (firstTwoChars == "PO") {
        //saat ini PO Reseller tidak menggunakan midtrans
        // this.$router.push({ name: "seller-pembelian" });
        window.location.href = this.memberMLMUrl + '/laporan/invoice-pv-activation?invoice=' + orderId
        return;
      } else {
        this.$router.push({ name: "transaction" });
      }
    });

    if (
      this.query.transaction_status &&
      this.query.transaction_status != "pending" &&
      this.query.transaction_status != "paid" &&
      this.query.transaction_status != "settlement"
    ) {
      let orderId = this.query.order_id;
      let firstTwoChars = orderId.slice(0, 2);
      if (firstTwoChars == "PO") {
        //saat ini tidak dipakai untuk seller, krn seller menggunakan deposit
        // this.$router.push({ name: "seller-pembelian" });
        window.location.href = this.memberMLMUrl + '/laporan/invoice-pv-activation?invoice=' + orderId
        return;
      } else {
        this.$router.push({ name: "transaction" });
      }
    }
  },
  beforeDestroy() {
    this.clearTransaction();
  }
};
</script>